import { VerificationComponent } from '@prodelio/modules/auth/features/verification/Verification.component';

export const VerificationPage = () => {
  return <VerificationComponent />;
};
